import React, { useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";

import _ from "lodash";
import { AiFillFileExcel, AiOutlineEdit } from "react-icons/ai";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

import moment from "moment";
import { MdDone, MdClear, MdVpnKey, MdSearch, MdRefresh } from "react-icons/md";
import EditReq from "./EditReq";
import config from "config.json";
import {
  getrequisition,
  approveReq,
  declineReq,
  exportRequisition,
} from "app/services/requisitionService";
import { useState } from "react";
import queryStringService from "app/services/queryStringService";

const { dateTimeFormat, apiUrl, dateFormat } = config;
const AllReq = () => {
  const [state, setState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    memId: 0,
    FromDate: "",
    ToDate: "",
    status: "Pending",
    ReqId: 0,
    showEditReq: false,
    RequisitionType: "",
  });
  const transactionAmountFormatter = (cell, row) => {
    return <span>₹{row.amount} </span>;
  };
  const transactionModeFormatter = (cell, row) => {
    return <span>{row.transferMethod?.toUpperCase()} </span>;
  };

  const dateFormater = (cell, row) => {
    if (cell) {
      return (
        new moment(cell).format(dateFormat) +
        "  " +
        moment(row.systemDate).format("HH:mm:ss")
      );
    }
  };

  const editReqHandler = (row) => {
    setState((prevState) => ({
      ...prevState,
      ReqId: row.id,
      showEditReq: true,
    }));
  };

  const statusColor = (cell, row) => {
    if (row.status == "Declined") {
      return <span className="text-danger">Declined</span>;
    }
    if (row.status == "Pending") {
      return <span className="text-primary">Pending</span>;
    }
    if (row.status == "Approved") {
      return <span className="text-success">Approved</span>;
    }
  };
  const actionFormatter = (cell, row) => {
    if (row.status == "Pending") {
      return (
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#editReqPopup"
            onClick={() => {
              editReqHandler(row);
            }}
          >
            <AiOutlineEdit className="text-dark mr-4" size={15}></AiOutlineEdit>
            Edit
          </Dropdown.Item>

          <Dropdown.Item
            href="#"
            onClick={() => {
              Swal.fire({
                title: `<h1>Approve Requisition </h1>`,

                html: `<h2> Balance: ${new Intl.NumberFormat("en-IN", {
                  maximumSignificantDigits: 3,
                }).format(row.amount)} </h2>  <h4><b> Ref No - ${
                  row.referenceNo
                }</b></h4> <h6> Username - ${
                  row.fromMember.uniqueIdentity
                } </h6> <h6>  Company - ${
                  row.fromMember.company
                }</h6>   <input type="hidden" id="hdnReqId" name="hdnReqId" value=${
                  row.id
                }>
                        <textarea style="height:100px;resize:none;;display: block;
                        margin-left: auto;
                        margin-right: auto;
                        width: 80%" id="Reqremarkid" name="Reqremarkid" placeholder="Remark ..." class="swal2-input form-control"></textarea>
                        </div>`,

                showCancelButton: true,
                confirmButtonText: "Approve",
                cancelButtonText: "Back",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    requisitionId: document.getElementById("hdnReqId").value,
                    remark: document.getElementById("Reqremarkid").value,
                    creditSettlement: document.getElementById("ReqcreditSettle")
                      ? document.getElementById("ReqcreditSettle").checked
                      : false,
                  };
                  const res = await approveReq(data);
                  return res;
                },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (result.value.status == "Success") {
                    Swal.fire({
                      icon: "success",
                      text: "Requisition approved successfully",
                    });
                    await loadTransaction();
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: "Requisition failed",
                    });
                  }
                }
              });
            }}
          >
            <MdDone className="text-success mr-4" size={15}></MdDone>
            Appove
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              Swal.fire({
                title: `Decline Requisition `,
                html: `<h1>Decline Requisition </h1>`,

                html: ` <h2> Balance: ${row.amount} </h2>  <h6> Username - ${row.fromMember.uniqueIdentity} </h6> <h6>  Company - ${row.fromMember.company}</h6>
                <input type="hidden" id="declineMemberId" value="${row.id}" />
                <textarea style="height:100px;resize:none;;display: block;
                margin-left: auto;
                margin-right: auto;
                width: 80%" id="declineremark" placeholder="Remark ..." class="swal2-input form-control"></textarea>`,

                showCancelButton: true,
                confirmButtonText: "Decline",
                cancelButtonText: "Back",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    requisitionId:
                      document.getElementById("declineMemberId").value,
                    remark: document.getElementById("declineremark").value,
                  };
                  const res = await declineReq(data);
                  return res;
                },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      text: "Requisition Declined successfully",
                      icon: "success",
                    });
                    await loadTransaction();
                  } else {
                    Swal.fire("Error occured");
                  }
                }
              });
            }}
          >
            <MdClear size={15} className="text-danger mr-4"></MdClear>
            Decline
          </Dropdown.Item>
        </DropdownButton>
      );
    } else if (row.status == "Declined") {
      return "";
    }
  };
  const columns = [
    {
      dataField: "fromMember.uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "fromMember.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionId",
      text: "Transaction Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "requestDate",
      text: "Req Date",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "approveDate",
      text: "Approval Date",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "pgType",
      text: "Req Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transferMethod",
      text: "Payment Mode",
      formatter: transactionModeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "referenceNo",
      text: "Ref. Number",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "bankName",
      text: "Bank",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: statusColor,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "remark",
      text: "Remark",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: transactionAmountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },

    {
      dataField: "memId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    const { loading } = state;
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransaction = async () => {
    const { page, sizePerPage, FromDate, ToDate, status, RequisitionType } =
      state;
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      status,
      RequisitionType,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }
    const response = await getrequisition(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setState((prev) => ({
      ...prev,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };

  useEffect(() => {
    loadTransaction();
  }, []);

  const refreshFilter = async (e) => {
    setState((prev) => ({
      ...prev,
      FromDate: "",
      ToDate: "",
      status: "",
      RequisitionType: "",
    }));
    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setState((prev) => ({ ...prev, page, sizePerPage }));
    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const handleSearch = async () => {
    setState((prev) => ({ ...prev, page: 1, sizePerPage: 10 }));

    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const handleExport = async () => {
    setState((prev) => ({ ...prev, page: 1, sizePerPage: 10 }));

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };
  const exportAllReq = async () => {
    const { FromDate, ToDate, TransactionMode, RequisitionType } = state;
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      TransactionMode,
      RequisitionType,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }

    const response = await exportRequisition(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_requisition.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setState((prev) => ({ ...prev, loading: false }));
  };

  const handleSearchChanges = (e) => {
    setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size </label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: state.dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>All Requisition</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "All Requisition" }]}></Breadcrumb>

      <div className="card mb-2">
        <div className="card-body">
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <label> Transaction Status</label>
              </div>
              <select
                className="form-control"
                placeholder="Transaction Status"
                name="status"
                value={state.status}
                onChange={handleSearchChanges}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approve</option>
                <option value="Declined">Decline</option>
              </select>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label> Transaction Mode</label>
              </div>
              <select
                className="form-control"
                placeholder="Transaction Type"
                name="RequisitionType"
                value={state.RequisitionType}
                onChange={handleSearchChanges}
              >
                <option value="NORMAL">Normal</option>
              </select>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label> Date From</label>
              </div>
              <input
                type="date"
                className="form-control"
                name="FromDate"
                value={state.FromDate}
                onChange={handleSearchChanges}
                max={moment().format("YYYY-MM-DD")}
              />
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label> Date To</label>
              </div>
              <input
                type="date"
                className="form-control"
                name="ToDate"
                value={state.ToDate}
                onChange={handleSearchChanges}
                max={moment().format("YYYY-MM-DD")}
              />
            </div>

            <div
              className="col d-flex justify-content-around"
              style={{ marginTop: "3%" }}
            >
              <button
                className="btn btn-outline-primary"
                onClick={handleSearch}
              >
                <MdSearch className="mx-2" size={18} />
              </button>
              <button className="btn btn-primary mx-1" onClick={refreshFilter}>
                Refresh
              </button>

              <Button variant="outline-primary" onClick={handleExport}>
                Export Excel
                <AiFillFileExcel className=" ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-3">
        <BootstrapTable
          hover
          remote
          keyField="uniqueIdentity"
          data={state.data}
          columns={columns}
          pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          noDataIndication={() => <NoDataIndication />}
          loading={state.loading}
          overlay={overlayFactory({
            spinner: true,
            styles: {
              overlay: (base) => ({
                ...base,
                background: "rgba(120, 120, 120, 0.5)",
                zIndex: "1",
              }),
            },
          })}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
      <EditReq
        ReqId={state.ReqId}
        showEditReq={state.showEditReq}
        loadTransaction={loadTransaction}
      />
    </>
  );
};
export default AllReq;
